import { CircularProgress } from '@mui/material';
import { AuthBoxContainer } from '@/components/AuthBox';
import { useEffect } from 'react';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { useCognitoAuth } from '@/services/auth';
import { useNavigate } from 'react-router-dom';

const CognitoSignInPage = () => {
  const { login, isAuthenticated } = useCognitoAuth();
  const { data: user, isLoading } = useGetCurrentUser({ skipRedirect: true, retry: false });
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthorized = !!user?.user;
    if (isLoading) {
      return;
    }
    if (isAuthenticated && isAuthorized) {
      navigate('/tenants');
    } else {
      login();
    }
  }, [isAuthenticated, user, isLoading]);

  return (
    <AuthBoxContainer>
      <CircularProgress size={24} sx={{ color: 'white' }} />
    </AuthBoxContainer>
  );
};

export default CognitoSignInPage;
